<!-- Search box of suggestions with suggestions upon complete. -->

<template>
  <div id="autocomplete-root" v-bind:class="{ responsive: mode == 'responsive', 'has-item': selectedItem != null && selectedItem != ''  }" >
    <div id="search-input-container">
        <CInput id="search-input" :label="$t('nameMandatory')" placeholder="" class="w-100" type="text" autocomplete="off" name="search" @focus="onFocus" @blur="onUnfocus" v-model="searchQuery" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter" :is-valid="isValid" :invalid-feedback="validationMessage"/>
    </div>
    <div class="autocomplete">
      <ul id="autocomplete-results" class="border-top" v-show="isActive">
        <li
          v-for="(result, i) in suggestions"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result"
          :class="{ 'is-active': i === searchArrowCounter }"
          v-html="result.description">         
        </li>   
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { IS_LOADING_STATUS } from "@/helpers/api.js";

export default {
    props: {
      value: {
          type: String,
          default: ''
      },
      mode: {
          type: String,
          default: 'full',
          enum: ['full', 'responsive']
      },
      isValid: {
          type: Function,
          default: () => { return null; }
      },
      validationMessage: {
          type: String,
          default: ''
      },
    },
    computed: {
    ...mapState('pois', ['suggestOutput']),
      suggestions: function()
      {
        return this.suggestOutput != IS_LOADING_STATUS && this.suggestOutput.object ? this.suggestOutput.object : [];
      }
    },
    data() {
      return {  
        isActive: false,
        searchQuery: this.value,
        awaitingSearch: false,
        searchArrowCounter: 0,
        selectedItem: null,
      }
    },
    methods: {
      ...mapActions('pois', ['suggestPlace']),
      onFocus() {
        this.isActive = this.searchQuery.length >= 3;

        this.$emit('focused');
      },
      onUnfocus() {
        this.$emit('unfocused');
      },
      setResult(result) {
        this.selectedItem = result;

        this.isActive = false;
      },
      onEnter(evt) {
        this.selectedItem =  this.suggestions[this.searchArrowCounter];

        this.isActive = false;
        this.searchArrowCounter = -1;

        document.activeElement.blur();
      },
      onArrowDown(evt) {
        if (this.searchArrowCounter < this.suggestions.length) {
          this.searchArrowCounter = this.searchArrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.searchArrowCounter > 0) {
          this.searchArrowCounter = this.searchArrowCounter -1;
        }
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isActive = false;
          this.searchArrowCounter = -1;
        }
      }
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    },
    watch:
    {
      value: function(val)
      {
        this.searchQuery = val;
      },
      searchQuery: function(val)
      {
        this.$emit('input', val);

        //

        var validQuery = this.searchQuery.length >= 3;

        if(validQuery && !this.selectedItem)
        {
          if(!this.awaitingSearch)
          {
            setTimeout(() => {
              this.suggestPlace(this.searchQuery);
              // this.isActive = true; will be set after the request is completed
              this.awaitingSearch = false;
            }, 1000); // 1 sec delay
          }
          this.awaitingSearch = true;
        }
        else
        {
          this.isActive = false;
        }
      },
      selectedItem: function (val) 
      {
        this.$emit('valueChanged', val);
      },
      isActive: function(val)
      {
        if(val)
        {
          this.$emit('showingResults');
        }
        else
        {
          this.$emit('hidingResults');
        }
      },
      suggestions: function(val)
      {
        this.isActive = this.searchQuery.length >= 3;
      }
    }
}
</script>

<style scoped>

    .autocomplete 
    {
      position: relative;
    }

    #autocomplete-results 
    {
      width: 85vw;
      max-width: 1400px; /* Max width of container */
      position: absolute;
      padding: 0;
      border-radius: 0 0 8px 8px;
      box-shadow: 0 0 4px 0 rgba(155,155,155,0.4);
      color: #303942;
      font-size: 16px;
      line-height: 24px;
      background-color:#FFFFFF;
      height: 30vh;
      overflow: auto;
      -ms-overflow-style: none;  /* IE 10+ */
      scrollbar-width: none;  /* Firefox */
      z-index: 999; /* Relevant in smaller devices */
      left: -1px; /* Compensate for roundings */
    }

    #autocomplete-results::-webkit-scrollbar 
    { 
      display: none;  /* Safari and Chrome */
    }

    #autocomplete-root .row
    {
        margin-right: 0;
        margin-left: 0;
    }

    #autocomplete-root, #search-input
    {
      padding-left: 0;
      padding-right: 0;
      width: auto;
      height: 100%;
    }

    #search-input
    {
      overflow: hidden;
    }

    .responsive #autocomplete-results
    {
      position: absolute;
      width: calc(100% + 15px); /* Take in consideration margins */
      min-width: 250px;
      margin-top: 8px;
      border-radius: 8px;
      left: -8px;
    }

    .autocomplete-result 
    {
      list-style: none;
      text-align: left;
      padding-top: 4px;
      padding-bottom: 4px;
      cursor: pointer;
      padding-left: 24px;
      padding-right: 24px;
    }

    .autocomplete-result.is-active,
    .autocomplete-result:hover 
    {
      background-color: #E7F7FD;    
    }

    #search-input-container
    {
      display: flex;
      flex-direction: row;
      align-self: center;
      height: 100%;
    }

    #autocomplete-root:not(.responsive) #search-input-container
    {
      padding-left: 56px;
    }

    /* Inputs */
    input
    {
        flex-grow: 2;
        border: none;
        font-size: 16px;
        line-height: 24px;
        color: #303942;  
        width: 100%;
        height: 100%;
    }
    
    .responsive input
    {
      font-size: 14px;
      line-height: 30px;
      height: 100%;
    }

    input:focus
    {
      outline: none;
    }

  @media only screen and (max-width: 600px) 
  {
    #autocomplete-root:not(.responsive) #autocomplete-results
    {
      width: 510px;
    }
  }

</style>